import { render, staticRenderFns } from "./AdministrationProductModal.vue?vue&type=template&id=4d52794e&scoped=true&"
import script from "./AdministrationProductModal.vue?vue&type=script&lang=js&"
export * from "./AdministrationProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52794e",
  null
  
)

export default component.exports